module.exports = __webpack_public_path__ + "img/product-6-INTglu.387ac013.png";